import { z } from 'zod';

export const agendaHeroSourceFormSchema = z.object({
  feedId: z.string().min(1, 'Please select an experience'),
});

export type AgendaHeroSourceFormValues = z.infer<
  typeof agendaHeroSourceFormSchema
>;
